export const registerServiceWorker = () => true

export const disableCorePrefetching = () => true
